<template>
  <v-row v-if="!onMobile" v-bind="$attrs">
    <v-col cols="4" class="col1">{{ rowHeader }}</v-col>
    <v-col cols="2" class="col1 text-right">{{ cb("yearly") }}</v-col>
    <v-col cols="2" class="col1 text-right">{{ cb("monthly") }}</v-col>
    <v-col cols="2" class="col1 text-right">{{ cb("weekly") }}</v-col>
    <v-col cols="2" class="col1 text-right">{{ cb("daily") }}</v-col>
  </v-row>
  <v-row v-else v-bind="$attrs">
    <v-col cols="4" class="col1">{{ rowHeader }}</v-col>
    <v-col cols="4" class="col1 text-right">{{ cb("yearly") }}</v-col>
    <v-col cols="4" class="col1 text-right">{{ cb("monthly") }}</v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    rowHeader: String,
    cb: Function
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
};
</script>

<style lang="scss" scoped>
.col0 {
  border-right: 1px solid gray;
}
.col1 {
  border-right: 1px solid lightgray;
}
.col2 {
  border-right: 1px solid white;
}
.col-bottom {
  border-right: 1px solid white;
}
</style>